module.exports = __webpack_public_path__ + "img/LA.445a9170.svg";